import React from 'react';

const BookNow = () => {
    return (
        <div className='my-5 my-2' >
            <h2> Welcome to Our Check Out page </h2>
        </div>
    );
};

export default BookNow;